import { memo } from 'react'
import { withRouter } from 'react-router-dom'
import { sessionStore } from '@/utils/storage'
import CommonFunc from '@/utils/common-func'
import BasicStep from '../BasicStep/BasicStep'
const LayoutStep = ({ history, step }: any) => {
  const LIST = [{ label: '上传内容' }, { label: '选择模板' }, { label: '排版结果' }]
  const onConfirm = (step: number) => {
    const cacheData = sessionStore.get('layoutData', {}) as any
    if (step == 1) {
      const layoutData = CommonFunc.omit(cacheData, ['treeExpandedKeys', 'value'])
      layoutData.pathname = '/articleLayout'
      sessionStore.set('layoutData', layoutData)
      history.push('/articleLayout')
    }
  }
  return <BasicStep list={LIST} step={step} isGradient={true} onConfirm={onConfirm} />
}

export default memo(withRouter(LayoutStep))
